import classnames from 'classnames';

const OverlayText = ({ overlay }) => {
    const { contentParams } = overlay;
    const classes = classnames('overlay-html', contentParams.className);

    return (
        <div className={classes} dangerouslySetInnerHTML={{__html: contentParams.html}} />
    )
}

export default OverlayText
